/*
 * Package: WebVideo.WebmasterPerson
 * Version: $Id$
 * Copyright (c) 2011-2015 Sergey Leonov
 */

function WebmasterPerson() {}

WebmasterPerson.FIELD_CUSTOM_PREFIX = "webmaster_custom_";
WebmasterPerson.FIELD_REFERRAL_WEBMASTER_ID = "wm";

WebmasterPerson.getFBConnectionUrl = function (login_redirect_url) {
  var _url = Config.webmaster + "/login/facebook";
  _url += "?webmaster_withdraw_type=2"; //PayeePerson.WITHDRAW_TYPE_PAYPAL = 2;
  _url += "&" + WebmasterPerson.FIELD_CUSTOM_PREFIX + "time_zone=" + TimeUtils.getTzNameByLocation(Config.location, Config.defaultTimezone);
  if (login_redirect_url != null) {
    _url += "&login_redirect_url=" + encodeURI(login_redirect_url);
  }
  return _url;
};

WebmasterPerson.initFBLogin = function (login_redirect_url) {
  FB.login(function(response) {
    if (response.status == 'connected') {
      document.location.href = WebmasterPerson.getFBConnectionUrl(login_redirect_url);
    }
  }, {perms:'email,user_birthday,user_about_me,user_photos'});
};

WebmasterPerson.submitJoinForm = function (form) {
  form.elements["webmaster_withdraw_type"].value = "2"; //PayeePerson.WITHDRAW_TYPE_PAYPAL = 2;
  form.elements[WebmasterPerson.FIELD_CUSTOM_PREFIX + "time_zone"].value = TimeUtils.getTzNameByLocation(Config.location, Config.defaultTimezone);
  return true;
};

WebmasterPerson.detectReferralId = function () {
  var regex = new RegExp("[\\#]"+WebmasterPerson.FIELD_REFERRAL_WEBMASTER_ID+"=(.+)");
  var qs = regex.exec(window.location.href);
  if (qs != null) {
    jQuery.ajax({
      "dataType": "json",
      "cache" : false,
      "type": "GET",
      "url": Config.exec + "/_ajaj-webvideo-gateway.jsp?"+WebmasterPerson.FIELD_REFERRAL_WEBMASTER_ID+"="+qs[1],
      "data": {
        "command": "get-referral-webmaster-id"
      }
    });
  }
};